import { Injectable, inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { CookieService } from 'ngx-cookie-service'
import { AFFILIATES_COOKIE } from './customer-navigation.service'

interface ProviderConfig {
  affiliate_name: string
  affiliate_id: string
  affiliate_slug: string
  variable_1: string
  variable_2: string
  cookie_life_time: string
  use_utm_tags: boolean
}

const PROVIDERS: Record<string, ProviderConfig> = {
  adtraction: {
    affiliate_name: 'Adtraction',
    affiliate_id: '1',
    affiliate_slug: 'adtraction',
    variable_1: 'at_gd',
    variable_2: 'aff_id',
    cookie_life_time: '30',
    use_utm_tags: true,
  },
}

@Injectable({
  providedIn: 'root',
})
export class AffiliatesService {
  private cookieService = inject(CookieService)
  private platformId = inject(PLATFORM_ID)

  handleQueryString(queryString: string | null) {
    if (!queryString) {
      return
    }
    if (!isPlatformBrowser(this.platformId)) {
      return
    }

    const raw = queryString.startsWith('?') ? queryString.slice(1) : queryString
    const params = new URLSearchParams(raw)
    const utmSource = params.get('utm_source') || ''
    if (!utmSource) {
      return
    }

    const provider = PROVIDERS[utmSource.toLowerCase()]
    if (!provider) return

    const cookieObj: any = {
      affiliate_name: provider.affiliate_name,
      affiliate_id: provider.affiliate_id,
      affiliate_slug: provider.affiliate_slug,
      variable_1: provider.variable_1,
      variable_2: provider.variable_2,
      cookie_life_time: provider.cookie_life_time,
      use_utm_tags: provider.use_utm_tags,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      session1: params.get(provider.variable_1) || '',
      session2: params.get(provider.variable_2) || '',
      timestamp: this.formatTimestamp(new Date()),
      exp_date: this.formatTimestamp(this.addDays(new Date(), Number(provider.cookie_life_time))),
      ip: '',
    }

    try {
      this.cookieService.set(AFFILIATES_COOKIE, JSON.stringify(cookieObj), Number(provider.cookie_life_time), '/')
    } catch (e) {
      console.error(e)
    }
  }

  private pad(n: number) {
    return n < 10 ? `0${n}` : `${n}`
  }

  private formatTimestamp(d: Date) {
    const yy = String(d.getFullYear()).slice(-2)
    const mm = this.pad(d.getMonth() + 1)
    const dd = this.pad(d.getDate())
    const hh = this.pad(d.getHours())
    const min = this.pad(d.getMinutes())
    const ss = this.pad(d.getSeconds())
    return `${yy}-${mm}-${dd} ${hh}:${min}:${ss}`
  }

  private addDays(d: Date, days: number) {
    const copy = new Date(d.getTime())
    copy.setDate(copy.getDate() + days)
    return copy
  }
}
